import MuiButton from './MuiButton'

export const components = {
  MuiButton,
}
